const values = (state) => state.values;
const access = (state) => state.access;
const success = (state) => state.success;
const fetching = (state) => state.fetching;
const minting = (state) => state.minting;
const error = (state) => state.error;

export default {
  values,
  access,
  success,
  fetching,
  minting,
  error,
};
